module.exports = __webpack_public_path__ + "static/media/mute.c488f770.svg";